import { defineMessage } from 'services/localization';

export const messages = {
    otherOptions: defineMessage('other_options'),
    newSubscriptionOption: defineMessage('add_this_organisation_to_new_subscription'),
};
